import React from "react";

const NotFound = () => {
  return (
    <div>
      <h3>ici 404</h3>
    </div>
  );
};

export default NotFound;
